<template>
  <v-app>
    <v-main>
      <v-img
        class="mb-4 mt-6 mx-auto"
        contain
        max-height="250"
        max-width="250"
        src="@/assets/logo.png"
      />
      <v-container>
        <div class="text-center mb-4">
          <v-btn class="ma-1" rounded color="blue" dark to="/"
            ><v-icon left> mdi-plus </v-icon>สมัครเรียน</v-btn
          >
          <v-btn class="ma-1" rounded color="green" dark to="/List"
            ><v-icon left> mdi-magnify </v-icon>ตรวจสอบรายชื่อผู้สมัครสอบ</v-btn
          >
          <v-col cols="auto">
            <v-dialog
              v-model="announceVisible"
              transition="dialog-bottom-transition"
              persistent
              max-width="800"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn color="warning" rounded v-bind="attrs" v-on="on"
                  ><v-icon left> mdi-account-plus </v-icon
                  >การรับนักเรียนเข้าศึกษาต่อ</v-btn
                >
              </template>
              <template v-slot:default="announce">
                <v-card>
                  <v-toolbar color="blue" dark>ประกาศสำคัญ</v-toolbar>
                  <v-card-text>
                    <v-img
                      class="mb-4 mt-6 mx-auto"
                      contain
                      src="@/assets/announce.png"
                    />
                  </v-card-text>
                  <v-card-actions class="justify-end">
                    <v-btn
                      color="error"
                      class="mx-auto"
                      @click="announce.value = false"
                      ><v-icon left> mdi-close </v-icon>ปิด</v-btn
                    >
                  </v-card-actions>
                </v-card>
              </template>
            </v-dialog>
          </v-col>
        </div>
        <v-alert border="top" colored-border type="error" elevation="2">
          หลักฐานและอุปกรณ์
          <br />ที่ต้องนำมาในวันสอบคัดเลือก <br />1. สำเนาทะเบียนบ้านนักเรียน 1
          ฉบับ <br />2. ใบรับรองผลการศึกษา ปพ.7 (ฉบับจริง) หรือสำเนา ปพ.1 1 ฉบับ
          <br />
          3. ดินสอ 2B, กบเหลาดินสอ, ยางลบ, ปากกาสีน้ำเงิน <br />
          4. นักเรียนทุกคนแต่งกายชุดนักเรียนและใส่หน้ากากอนามัย
          <p />
          * วันสอบคัดเลือก* <br />นักเรียนชั้น ม. 1 วันเสาร์ที่ 26 มี.ค. 2565
          เวลา 08.00-12.00 น. <br />นักเรียนชั้น ม. 4 วันอาทิตย์ที่ 27 มี.ค.
          2565 เวลา 08.00-12.00 น.
          <p />
          เวลา 08.00 น. นักเรียนทุกคนฟังประชุมชี้แจง ณ อาคารอเนกประสงค์ (โดม)
          โรงเรียนหัวหิน
          <p />
          วิชาที่สอบ ภาษาไทย คณิตศาสตร์ วิทยาศาสตร์ สังคมศึกษา และภาษาอังกฤษ
        </v-alert>

        <router-view />
      </v-container>

      <v-footer padless style="background-color: #3db2ff">
        <v-col class="text-center" cols="12" style="color: #ffffff">
          <p>
            ควบคุมและดูแลระบบโดย: คุณครูจิตราภรณ์ ไกรวรรณ์<br />
            ออกแบบและพัฒนาระบบโดย: นายภาณุนันต์ ศักดี <br />
          </p>
          © 2022 Copyright:
          <a
            style="color: #ffffff"
            class="text-white"
            data-toggle="tooltip"
            data-placement="top"
            title="Founded by SinnyX (ภาณุนันต์ ศักดี)"
            >SIMMIFLOW DESIGN by Panunan Sakdee (SinnyX)</a
          >
        </v-col>
      </v-footer>
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: "App",

  data: () => ({
    announceVisible: false,
  }),
};
</script>

<style>
#app {
  font-family: "Sarabun", sans-serif;
  background-color: #3db2ff;
}
</style>
